import { render, staticRenderFns } from "./SharingDetailsPopup.vue?vue&type=template&id=413de13c&scoped=true&"
import script from "./SharingDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./SharingDetailsPopup.vue?vue&type=script&lang=js&"
import style0 from "./SharingDetailsPopup.vue?vue&type=style&index=0&id=413de13c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413de13c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('413de13c')) {
      api.createRecord('413de13c', component.options)
    } else {
      api.reload('413de13c', component.options)
    }
    module.hot.accept("./SharingDetailsPopup.vue?vue&type=template&id=413de13c&scoped=true&", function () {
      api.rerender('413de13c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileExplorer/SharingDetailsPopup.vue"
export default component.exports